import React, {useCallback} from 'react';

import Icon from '../../elements/icons/Icon';
import LoadLocations from '../../loaders/LoadLocations';
import Location from '../Meetings/Location/Location';
import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import WaitWhileBusy from '../../WaitWhileBusy';
import {useI18n} from '../../../data/hooks/i18nHooks';
import {useEventLocations} from '../../../data/hooks/locationHooks';
import {useParams} from 'react-router';
import {useEvent, useEventHasMap} from '../../../data/hooks/eventHooks';

export const EventMeetingLocations = props => {
    const {eventId, onReturn} = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        locations = useEventLocations(eventId),
        hasMap = useEventHasMap(eventId);

    const handleShowMap = useCallback(() => {
        app.store.dispatch(app.actions.ui.sidePanel.showEventMap( true));
    }, [eventId]);

    const header = (
        <div>
            <TopBarEvent
                event={event}
                onReturnClick={onReturn}
                icons={[hasMap ? <Icon key="map" src="/img/event_map.png" color="white" onClick={handleShowMap} /> : null]}>
                {i18n['label.metting']}
            </TopBarEvent>
            <hr />
        </div>
    );

    return (
        <Screen header={header}>
            <Scrollable>
                <div className="content">
                    <p>{event.meetingpoints_description}</p>
                    {locations.map(location => (
                        <Location key={location.id} event={event} location={location} />
                    ))}
                </div>
            </Scrollable>
        </Screen>
    );
};

export default props => {
    const {eventId} = useParams();
    return (
        <LoadLocations eventId={eventId}>
            <WaitWhileBusy>
                <EventMeetingLocations eventId={eventId} />
            </WaitWhileBusy>
        </LoadLocations>
    );
};
